// Messages for operator/Audit (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.audit.head': 'Audit log — Operator',
  'operator.audit.title': 'Audit log',
  'operator.audit.desc': 'Append-only record of privileged changes.',
  'operator.audit.col.when': 'When',
  'operator.audit.col.action': 'Action',
  'operator.audit.col.record': 'Record',
  'operator.audit.col.changed': 'Changed',
  'operator.audit.col.actor': 'Actor',
  'operator.audit.col.ip': 'IP',
  'operator.audit.empty': 'No audit events yet.',
  'operator.audit.showing': 'Showing {first}–{last} of {total}',
  'operator.audit.page': 'Page {page} of {pages}',
  'operator.audit.prev': 'Previous',
  'operator.audit.next': 'Next',
}

export const zhTW = {
  'operator.audit.head': '稽核紀錄 — 操作員',
  'operator.audit.title': '稽核紀錄',
  'operator.audit.desc': '僅追加的特權變更紀錄。',
  'operator.audit.col.when': '時間',
  'operator.audit.col.action': '動作',
  'operator.audit.col.record': '紀錄',
  'operator.audit.col.changed': '變更',
  'operator.audit.col.actor': '操作者',
  'operator.audit.col.ip': 'IP',
  'operator.audit.empty': '尚無稽核事件。',
  'operator.audit.showing': '顯示第 {first}–{last} 筆，共 {total} 筆',
  'operator.audit.page': '第 {page} / {pages} 頁',
  'operator.audit.prev': '上一頁',
  'operator.audit.next': '下一頁',
}
